/* lozenge.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDzXzM%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._1mT5xd5HSx%7Bposition%3Astatic%7D%0A._3L9DPXBY1A%7Bblock-size%3A-moz-min-content%3Bblock-size%3Amin-content%7D%0A._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D%0A._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D%0A._3e6OgrA17z%7Boutline-offset%3A-1px%7D%0A._0WKd3G4z3T%7Bfont-family%3Avar(--ds-font-family-body%2C%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._4ya3eEdLIE%7Bfont-size%3A11px%7D%0A._2l4i3rzUZr%7Bfont-style%3Anormal%7D%0A._1kk5Tkmb2E%7Bfont-weight%3Avar(--ds-font-weight-bold%2C653)%7D%0A._26BoRwey7F%7Bline-height%3A1pc%7D%0A._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D%0A._41LZZBAv7U%7Btext-transform%3Auppercase%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._3iugoSrrwU%7Bletter-spacing%3A.165px%7D%0A._0KLXru1qiM%7Bbackground-color%3A%23dddee1%7D%0A._0KLXru1tR5%7Bbackground-color%3A%238fb8f6%7D%0A._0KLXruBh49%7Bbackground-color%3A%23f9c84e%7D%0A._0KLXruyx6K%7Bbackground-color%3A%23d8a0f7%7D%0A._0KLXruicO2%7Bbackground-color%3A%23fd9891%7D%0A._0KLXruK1e6%7Bbackground-color%3A%23b3df72%7D%0A._0KLXru66of%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D%0A._2xIroYT3oA%7Boutline-color%3A%23b7b9be%7D%0A._497WNw6wH8%7Boutline-style%3Asolid%7D%0A._2zndICHZdu%7Boutline-width%3A1px%7D%0A._2xIroYTOnn%7Boutline-color%3A%23669df1%7D%0A._2xIroYmPNR%7Boutline-color%3A%23fca700%7D%0A._2xIroYEWfT%7Boutline-color%3A%23c97cf4%7D%0A._2xIroYbxQq%7Boutline-color%3A%23f87168%7D%0A._2xIroYc0Gz%7Boutline-color%3A%2394c748%7D%0A._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A._1UtDYzDTSe%7Bcolor%3A%23292a2e%7D");



































import { type CSSProperties, memo, type ReactNode, useMemo } from 'react';
import NewLozenge from './new/lozenge';
import { type SemanticColor } from './new/types';
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */
const styles = {
  container: "_0bjKvDzXzM _4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _24h04i2Njc _1mT5xd5HSx _3L9DPXBY1A _0LQT5E1Y8M _03SyCP1Y8M",
  containerSubtle: "_3e6OgrA17z",
  text: "_4bt5LAnQyn _2WAcuGnQyn _0WKd3G4z3T _4ya3eEdLIE _2l4i3rzUZr _1kk5Tkmb2E _26BoRwey7F _39HuIbz8Lp _41LZZBAv7U _1ANEUSLRg7",
  customLetterspacing: "_3iugoSrrwU",
  'bg.bold.default': "_0KLXru1qiM",
  'bg.bold.inprogress': "_0KLXru1tR5",
  'bg.bold.moved': "_0KLXruBh49",
  'bg.bold.new': "_0KLXruyx6K",
  'bg.bold.removed': "_0KLXruicO2",
  'bg.bold.success': "_0KLXruK1e6",
  'bg.subtle.default': "_0KLXru66of",
  'bg.subtle.inprogress': "_0KLXru66of",
  'bg.subtle.moved': "_0KLXru66of",
  'bg.subtle.new': "_0KLXru66of",
  'bg.subtle.removed': "_0KLXru66of",
  'bg.subtle.success': "_0KLXru66of",
  'outline.subtle.default': "_2xIroYT3oA _497WNw6wH8 _2zndICHZdu",
  'outline.subtle.inprogress': "_2xIroYTOnn _497WNw6wH8 _2zndICHZdu",
  'outline.subtle.moved': "_2xIroYmPNR _497WNw6wH8 _2zndICHZdu",
  'outline.subtle.new': "_2xIroYEWfT _497WNw6wH8 _2zndICHZdu",
  'outline.subtle.removed': "_2xIroYbxQq _497WNw6wH8 _2zndICHZdu",
  'outline.subtle.success': "_2xIroYc0Gz _497WNw6wH8 _2zndICHZdu",
  'text.subtle': "_1UtDYzy7kJ",
  'text.bold': "_1UtDYzDTSe"
};
export type ThemeAppearance = 'default' | 'inprogress' | 'moved' | 'new' | 'removed' | 'success';
const appearanceTypes: ThemeAppearance[] = ['default', 'inprogress', 'moved', 'new', 'removed'];
const newSemanticColors: ThemeAppearance | SemanticColor[] = ['success', 'discovery', 'warning', 'danger', 'information', 'neutral'];
const appearanceMapping: Record<ThemeAppearance | SemanticColor, ThemeAppearance> = {
  neutral: 'default',
  default: 'default',
  information: 'inprogress',
  inprogress: 'inprogress',
  warning: 'moved',
  moved: 'moved',
  removed: 'removed',
  danger: 'removed',
  success: 'success',
  discovery: 'new',
  new: 'new'
};
export interface LozengeProps {
  /**
   * The appearance type.
   */
  appearance?: ThemeAppearance;

  /**
   * Elements to be rendered inside the lozenge. This should ideally be just a word or two.
   */
  children?: ReactNode;

  /**
   * Determines whether to apply the bold style or not.
   * @deprecated Deprecated. Will be removed in a future major release. Lozenge will be bold by default. For labels and categorization, use Tag instead.
   */
  isBold?: boolean;

  /**
   * max-width of lozenge container. Default to 200px.
   */
  maxWidth?: number | string;

  /**
   * Style customization to apply to the badge. Only `backgroundColor` and `color` are supported.
   * @deprecated This prop is deprecated and will be removed in an upcoming major release. Accent colors will be supported through the `appearance` prop in a future release.
   */
  style?: Pick<CSSProperties, 'backgroundColor' | 'color'>;

  /**
   * A `testId` prop is provided for specified elements, which is a unique
   * string that appears as a data attribute `data-testid` in the rendered code,
   * serving as a hook for automated tests
   */
  testId?: string;
}

/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */
const LegacyLozenge = memo(({
  children,
  testId,
  isBold = false,
  appearance = 'default',
  maxWidth = 200,
  style
}: LozengeProps) => {
  const appearanceStyle = isBold ? 'bold' : 'subtle';
  const appearanceType = useMemo(() => appearanceTypes.includes((appearance as ThemeAppearance)) || newSemanticColors.includes((appearance as SemanticColor)) ? appearanceMapping[appearance] : 'default', [appearance]);
  const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
  const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
  return <span style={{
    backgroundColor: style?.backgroundColor,
    maxWidth: maxWidthIsPc ? maxWidth : '100%'
  }} data-testid={testId} className={ax([styles.container, styles[`bg.${appearanceStyle}.${appearanceType}`], appearanceStyle === 'subtle' && styles[`outline.subtle.${appearanceType}`], appearanceStyle === 'subtle' && styles.containerSubtle])}>
				<span style={{
      color: style?.color,
      // to negate paddingInline specified on Box above
      maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
    }} data-testid={testId && `${testId}--text`} className={ax([styles.text, styles.customLetterspacing, styles[`text.${appearanceStyle}`]])}>
					{children}
				</span>
			</span>;
});
LegacyLozenge.displayName = 'Lozenge';
export default NewLozenge;